import React, { useContext, useEffect, useState, useRef } from 'react';
import { Input, TextArea, RadioGroup } from '@progress/kendo-react-inputs';
import DeleteFormItem from '../../DeleteFormItem';
import { LocalizationContext } from '../../../contexts';
import Uploader, { uploaderTypes } from '../../Uploader';
import PublishSwitch from '../publishSwitch';
import './index.scss';
import '../forms.scss';

export default function Triple({ data, updateFullCompData, type, ...rest }) {
  const emptyTripleItem = { title: "", text: "", image: "", image_mobile: "", animate_json: "", animate_json_mobile: "", link: "", link_target: "_top", isPublish: false };
  const emptyItem = useRef({ title: "", items: [{ ...emptyTripleItem }, { ...emptyTripleItem }, { ...emptyTripleItem }] });
  const [compData, setCompData] = useState({});
  const [localization] = useContext(LocalizationContext);
  const { labels } = localization;

  useEffect(() => {
    const defaultData = { ...emptyItem.current };
    setCompData({ ...defaultData, ...JSON.parse(JSON.stringify(data ? data : {})) });
  }, [data]);

  const handleDeleteClick = () => {
    const newCompData = { ...compData, ...emptyItem.current };
    setCompData(newCompData);
    updateFullCompData(newCompData, type);
  };

  const updateItem = (i, newData) => {
    let newCompData = { ...compData };
    if (i !== null) {
      newCompData.items[i] = { ...compData.items[i], ...newData };
    } else {
      newCompData = { ...compData, ...newData };
    }

    setCompData(newCompData);
    updateFullCompData(newCompData, type);
  }

  const isEmptyItem = () => {
    return JSON.stringify(compData) === JSON.stringify(emptyItem.current)
  }

  const showRequired = (item, requiredField) => {
    let noRequiredField;
    if (requiredField?.length > 1) {
      noRequiredField = (!item[requiredField[0]] && !item[requiredField[1]]) || (item[requiredField[0]] && item[requiredField[1]])
    } else {
      noRequiredField = !item;
    }
    return !isEmptyItem() && noRequiredField;
  }

  const canPublish = (item) => {
    if (!item.title || !item.text ||
      !(item.image_mobile || item.animate_json_mobile) ||
      !(item.image || item.animate_json)) {
      return false;
    }
    return true;
  }

  return (
    <div className="form-item">
      <div className="form-item__title">
        {labels.pagesManagement.forms.must_add_3_triple_items}
        {!isEmptyItem() && <DeleteFormItem handleDeleteClick={handleDeleteClick} />}
      </div>
      <div className="form-field">
        <label className="form-field__label mandatory">{labels.pagesManagement.forms.add_triple_title}</label>
        <Input name={'title'} value={compData.title} onChange={({ value }) => updateItem(null, { title: value })}></Input>
        {showRequired(compData.title) && <div className="form-field__required">{labels.pagesManagement.forms.required}</div>}
      </div>
      <div className="form-items">
        {compData.items?.map((item, i) => {
          return (
            <div key={i} className="form-item">
              <div className="form-item__title">
                {labels.pagesManagement.forms.item} {i + 1}
              </div>
              <div className="form-field">
                <label className="form-field__label mandatory">{labels.pagesManagement.forms.add_title}</label>
                <Input name={'title'} value={item.title} onChange={({ value }) => updateItem(i, { title: value })}></Input>
                {showRequired(item.title) && <div className="form-field__required">{labels.pagesManagement.forms.required}</div>}
              </div>
              <div className="form-field">
                <label className="form-field__label mandatory">{labels.pagesManagement.forms.add_text}</label>
                <TextArea name={'text'} value={item.text} onChange={({ value }) => updateItem(i, { text: value })}></TextArea>
                {showRequired(item.text) && <div className="form-field__required">{labels.pagesManagement.forms.required}</div>}
              </div>
              <div className="form-field">
                <label className="form-field__label">{labels.pagesManagement.forms.add_pc_banner}</label>
                <Uploader type={uploaderTypes.image} imageUrl={item.image} prefix={'triple'} onChange={(file) => { updateItem(i, { image: file }) }} />
              </div>
              <div className="form-field separator"><label className="form-field__label">{labels.pagesManagement.forms.or}</label></div>
              <div className="form-field">
                <label className="form-field__label">{labels.pagesManagement.forms.add_pc_animation}</label>
                <Uploader type={uploaderTypes.animation} animationUrl={item.animate_json} prefix={'triple'} onChange={(file) => { updateItem(i, { animate_json: file }) }} />
                {showRequired(item, ['image', 'animate_json']) && <div className="form-field__required">{labels.pagesManagement.forms.required_image_or_animation}</div>}
              </div>
              <div className="form-field">
                <label className="form-field__label">{labels.pagesManagement.forms.add_mobile_banner}</label>
                <Uploader type={uploaderTypes.image} imageUrl={item.image_mobile} prefix={'triple'} onChange={(file) => { updateItem(i, { image_mobile: file }) }} />
              </div>
              <div className="form-field separator"><label className="form-field__label">{labels.pagesManagement.forms.or}</label></div>
              <div className="form-field">
                <label className="form-field__label">{labels.pagesManagement.forms.add_mobile_animation}</label>
                <Uploader type={uploaderTypes.animation} animationUrl={item.animate_json_mobile} prefix={'triple'} onChange={(file) => { updateItem(i, { animate_json_mobile: file }) }} />
                {showRequired(item, ['image_mobile', 'animate_json_mobile']) && <div className="form-field__required">{labels.pagesManagement.forms.required_image_or_animation}</div>}
              </div>
              <div className="form-field">
                <label className="form-field__label">{labels.pagesManagement.forms.add_link}</label>
                <Input name={'link'} value={item.link} onChange={({ value }) => updateItem(i, { link: value })}></Input>
                <RadioGroup data={[
                  { label: labels.pagesManagement.forms.open_top, value: '_top' },
                  { label: `${labels.pagesManagement.forms.open_blank} (${labels.pagesManagement.forms.for_external_links})`, value: '_blank' }
                ]}
                  layout='horizontal'
                  value={item.link_target}
                  onChange={({ value }) => {
                    updateItem(i, { link_target: value });
                  }}
                />
              </div>
              <PublishSwitch isPublish={item?.isPublish} canPublish={canPublish(item)}
                updateItem={(event) => updateItem(i, { isPublish: event.target.value })} />

            </div>);
        })}
      </div>

      {/* <div style={{ marginTop: 20 }}>{JSON.stringify(compData)}</div> */}
    </div>
  );
};